let tasksRemaining = ["this is first task", "this is second task", "this is third task"]

export default tasksRemaining;